import {
  buildTiptapDocument,
  mentionBlock,
  paragraphBlock,
  textBlock,
} from "@circle-react-uikit/TipTap/utilities/contentBuilder";
import { useMemo } from "react";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import type { BasicCommunityMember } from "@/react/types/CommunityMember";
import type { TiptapBody } from "@/react/types/RichTextField";

const buildMentionPrefill = (
  member: BasicCommunityMember | null | undefined,
  currentCommunityMemberId: number | undefined,
): Pick<TiptapBody, "body" | "sgids_to_object_map"> | null => {
  if (!member) return null;

  const { id, type, rich_text_field_sgid: sgid } = member;
  const isSelf = id === currentCommunityMemberId;
  const isHumanMember = type === "CommunityMember";
  if (!sgid || isSelf || !isHumanMember) return null;

  return {
    ...buildTiptapDocument({
      bodyContent: [
        paragraphBlock({
          content: [mentionBlock({ sgid }), textBlock({ text: " " })],
        }),
      ],
    }),
    sgids_to_object_map: { [sgid]: member },
  };
};

export const useComposerMentionPrefill = (
  mentionCommunityMember?: BasicCommunityMember | null,
) => {
  const { currentCommunityMember } = usePunditUserContext();

  // Keep referentially stable — useComposerActivation depends on it; a new object each render cancels the queued focus/prefill timer.
  return useMemo(
    () =>
      buildMentionPrefill(mentionCommunityMember, currentCommunityMember?.id),
    [mentionCommunityMember, currentCommunityMember?.id],
  );
};
